import { takeLatest, call, put } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { loginRequested, loginSucceeded, loginFailed } from '../reducers/auth.slice';
import AuthAPIService from '../../services/auth.service';

function* login(
  action: PayloadAction<{ walletAddress: string; chainId: number; signature: string }>,
): Generator<unknown, void, unknown> {
  try {
    const { walletAddress, chainId, signature } = action.payload;
    const service = new AuthAPIService();
    const res = yield call([service, service.login], walletAddress, chainId, signature);

    yield put({ type: loginSucceeded.type, payload: res });
  } catch (error: any) {
    console.log('saga::login::', error.message);
    yield put<{ type: string; payload: SagaError }>({ type: loginFailed.type, payload: { message: error.message } });
  }
}

export default function* watchAsync() {
  yield takeLatest(loginRequested.type, login);
}
